import { pickEnv } from './constants'

export const API_DOMAIN = pickEnv(
  '$API_BASE_URL',
  `https://api.${process.env.LOCALHOST_BE_ENV}.bonrepublic.com`
)

export const OIDC_DOMAIN = pickEnv(
  '$OIDC_BASE_URL',
  `https://auth.internal.bonrepublic.com`
)

export const CLIENT_ID = pickEnv(
  '$CLIENT_ID',
  `https://auth.internal.bonrepublic.com`
)

export const REALM = pickEnv('$REALM', `https://auth.internal.bonrepublic.com`)
export const IDP_HINT = pickEnv('$IDP_HINT', ``)

export const API_RESPONSE_STATUS_UNAUTHORIZED = 401
export const API_RESPONSE_STATUS_FORBIDDEN = 403
export const API_RESPONSE_STATUS_NOT_FOUND = 404
export const API_RESPONSE_STATUSES_SERVER_ERRORS = [500, 502, 503, 504]

export enum API_ORDER_DIRECTION {
  ASC = '+',
  DESC = '-',
}

export const API_ORDERING_PARAM = 'ordering'
